import { DataTableSortOrderType } from "primereact/datatable";

export const nameof = <T>(key: keyof T): string => key as string;

export const formatFixer = (value: number): string => {
  return value < 10 ? `0${value}` : value.toString();
};

export const formatDateToUtc = (date: Date): Date => {
  const day: string = formatFixer(date.getDate());
  const month: string = formatFixer(date.getMonth() + 1);
  const year: string = date.getFullYear().toString();

  const dateString = `${year}-${month}-${day}T00:00:00.000Z`;

  return new Date(dateString);
};

export const getGuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const getCurrentYear = (): number => new Date().getFullYear();

export const getCurrentQuarter = (): string => {
  const currentMonth = new Date().getMonth() + 1;
  const quarter = Math.ceil(currentMonth / 3);

  return `Q${quarter}`;
};

export const getSecondsFromDays = (days: number) => {
  const secondsInADay = 24 * 60 * 60;
  return days * secondsInADay;
};

export function placeCurrentYearFirst(years: number[]) {
  const currentYear = new Date().getFullYear();
  const updatedYears = [currentYear, ...years.filter(year => year !== currentYear)];
  return updatedYears;
}

export function dataTableSortOrderTypeToString(orderType: DataTableSortOrderType){
  if(orderType === 1){
    return "asc";
  }

  if(orderType === -1){
    return "desc";
  }

  return "desc";
}

export function stringToDataTableSortOrderType(order: string | undefined){
  if(order === "asc"){
    return 1;
  }

  if(order === "desc"){
    return -1;
  }

  return -1;
}
